module.exports = require('scryptsy')



//////////////////
// WEBPACK FOOTER
// ./~/scrypt.js/js.js
// module id = 836
// module chunks = 0